'use strict';

/**
 * Overview for the sets
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var BaseLayout = require('./base');
var DetailView = require('../partials/detail');

var template = require('modules/collection/templates/layout/detail.hbs');

var DetailLayout = BaseLayout.extend({
    template: template,

    className: 'objects-container',

    regions: {
        detailsRegion: '.object-details-region',
    },

    ui: {
        'closeLink': 'a.close',
    },

    events: {
        'change @ui.changeSort': 'changeSort',
        'click @ui.closeLink': 'close',
    },

    initialize: function (options) {
        BaseLayout.prototype.initialize.apply(this, arguments);
        options = _.extend({}, options);
        this.params = options.params;
        this.viewData.closeUrl = this.params.getPath();
    },

    onAttach: function () {
        // BaseLayout.prototype.onAttach.apply(this);
        $('body').addClass('is-detail-mode');
    },

    onBeforeShow: function() {
        var previousModel = this.collection.getPreviousModel(this.model);
        var prevLinkUrl = previousModel ? this.params.getPath(previousModel) : null;
        var nextModel = this.collection.getNextModel(this.model);
        var nextLinkUrl = nextModel ? this.params.getPath(nextModel) : null;
        this.detailsRegion.show(new DetailView({
            model: this.model,
            prevLinkUrl: prevLinkUrl,
            nextLinkUrl: nextLinkUrl,
            closeLinkUrl: this.params.getPath(),
            settings: this.params,
        }));
    },

    close: function(event) {
        event.preventDefault();
        App.router.navigate(this.viewData.closeUrl + '/scrollTo/' + this.model.attributes.id, {trigger: true, replace: true});
        $('body').removeClass('is-detail-mode');
    },
});

module.exports = DetailLayout;